import type { HTMLAttributes } from 'react';
import { cn } from '~/lib/cn';

type Variant = 'default' | 'subtle' | 'accent' | 'destructive' | 'success' | 'outline';

const variants: Record<Variant, string> = {
  default: 'bg-foreground text-background',
  subtle: 'bg-muted text-foreground',
  accent: 'bg-[var(--color-accent-soft)] text-[var(--color-accent)]',
  destructive: 'bg-destructive/10 text-destructive',
  success: 'bg-[color-mix(in_srgb,var(--color-success)_15%,transparent)] text-[var(--color-success)]',
  outline: 'border border-border text-foreground',
};

export function Badge({
  className,
  variant = 'subtle',
  ...rest
}: HTMLAttributes<HTMLSpanElement> & { variant?: Variant }) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium tracking-[0.02em]',
        variants[variant],
        className,
      )}
      {...rest}
    />
  );
}
